export default {
    "updateConsentPermission": "431b8659d06bc9a78b7145128a3e73baf3660ccab13154dafcaac9aa16fb3d53"
};
